import React from 'react';
import FullPageSimulator from '../FullPageSimulator';
import MethodCard from '../../AuxiliaryComponent/ButtonComponent/MethodCard';
import { hand_type, scan_barcode } from '../../../../utils/ImagesManagementUtils';
import { Android } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const SelectMethodFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const { select_bill } = globJSON.configurations.services.pay_bills_0;
  const { enable_customer_to_scan_barcode } = select_bill;

  return (
    <FullPageSimulator
      globJSON={globJSON}
      slideshowRefs={slideshowRefs}
      simPlatform={simPlatform}
      headlineText={select_bill.add_new_bill}
    >
      {enable_customer_to_scan_barcode && simPlatform === Android && (
      <MethodCard
        globJSON={globJSON}
        text={select_bill.scan_barcode}
        isBlueBorder={enable_customer_to_scan_barcode}
        source={scan_barcode}
      />
      )}
      <MethodCard
        globJSON={globJSON}
        text={select_bill.type_the_barcode}
        isBlueBorder={!enable_customer_to_scan_barcode}
        showOneMethod={!enable_customer_to_scan_barcode}
        source={hand_type}
      />
    </FullPageSimulator>
  );
};

export default SelectMethodFP;
